// extracted by mini-css-extract-plugin
export var sidebarStyles = "sidebar-module--sidebarStyles--OeI+N";
export var menuStyles = "sidebar-module--menuStyles--kmXKy";
export var socialNavStyles = "sidebar-module--socialNavStyles--c5uIA";
export var socialAnchorStyles = "sidebar-module--socialAnchorStyles--UK9PG";
export var glitchStyles = "sidebar-module--glitchStyles--b94FC";
export var primaryMenuStyles = "sidebar-module--primaryMenuStyles--ZBdTZ";
export var activeStyles = "sidebar-module--activeStyles--4BaF4";
export var toggleStyles = "sidebar-module--toggleStyles--Jsndj";